import { render, staticRenderFns } from "./ModalFirm.vue?vue&type=template&id=4544a32a"
import script from "./ModalFirm.vue?vue&type=script&lang=js"
export * from "./ModalFirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports